import { z } from 'zod';

/**
 * Cursor pagination for time-series resources (points, logs, alerts) where
 * offset pagination would drift as rows are inserted; page pagination for
 * ordinary CRUD lists where jumping to page 7 is a real user need.
 */

export const DEFAULT_PER_PAGE = 25;
export const MAX_PER_PAGE = 100;
/** Ingest-adjacent reads may pull more per request. */
export const MAX_PER_PAGE_POINTS = 200;

export const CursorQuerySchema = z.object({
  cursor: z.string().optional(),
  perPage: z.coerce.number().int().positive().max(MAX_PER_PAGE).default(DEFAULT_PER_PAGE),
});
export type CursorQuery = z.infer<typeof CursorQuerySchema>;

export const PageQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  perPage: z.coerce.number().int().positive().max(MAX_PER_PAGE).default(DEFAULT_PER_PAGE),
  sort: z.string().optional(),
  order: z.enum(['asc', 'desc']).default('desc'),
  search: z.string().max(200).optional(),
});
export type PageQuery = z.infer<typeof PageQuerySchema>;

export const DateRangeQuerySchema = z.object({
  from: z.string().date(),
  to: z.string().date(),
});
export type DateRangeQuery = z.infer<typeof DateRangeQuerySchema>;
